<template>
  <app-information-msg-component
    :libelleList="warningMessages"
    :canClose="false"
    typeMessage="is-warning"
    classLibelle="has-text-warning-dark">
  </app-information-msg-component>
</template>

<script>
import AppInformationMsgComponent from '@/components/general/informationMsgComponent';

export default {
  name: 'contact-warning-message',
  props: {
    contacts: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },
  components: {
    AppInformationMsgComponent,
  },
  computed: {
    warningMessages() {
      return this.contacts.map(intervenantContact => ({
        userId: intervenantContact.contact.id,
        islink: false,
        libelle: this.$t('detailContact.warning.archivedContact', {
          name: intervenantContact.contact.nom + ' ' + intervenantContact.contact.prenom,
        }),
      }));
    },
  },
};
</script>
